import { axiosWithAuth } from "helpers";

export const notificationSettingsService = {
	getNotificationSettings,
	updateNotificationSettings,
	deleteNotificationSettings,
};

const API_URL = process.env.REACT_APP_API_URL;

function getNotificationSettings({ userId }: { userId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/users/${userId}/notification_settings`,
	};

	return axiosWithAuth(options);
}

function updateNotificationSettings({
	userId,
	notificationSettingsId,
	fieldId,
}: {
	userId: string;
	notificationSettingsId: string;
	fieldId: string;
}) {
	const options = {
		method: "POST",
		data: fieldId,
		url: `${API_URL}/api/users/${userId}/notification_settings/${notificationSettingsId}/notifications`,
	};

	return axiosWithAuth(options);
}

function deleteNotificationSettings({
	userId,
	notificationSettingsId,
	fieldId,
}: {
	userId: string;
	notificationSettingsId: string;
	fieldId: string;
}) {
	const options = {
		method: "DELETE",
		data: fieldId,
		url: `${API_URL}/api/users/${userId}/notification_settings/${notificationSettingsId}/notifications`,
	};

	return axiosWithAuth(options);
}
